import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'

import { FEATURES, hasFeatureFlag } from '@cinch/oxd-utils/feature-flags/src'
import OxfordHomePage from '@cinch/oxd-pages/home/src'
import HomePage from '@cinch/oxd-pages/cambridge/home/src'

import SEO from '../components/seo'

const Home: React.FC = () => {
  const data: any = useStaticQuery(graphql`
    query HomeQuery {
      allTranslations {
        edges {
          node {
            home {
              seo {
                title
                description
              }
              heading
              subheading
              body
              bodySub
              filterHeading
              getStartedCtaSelectCar
              getStartedCtaNotSure
              ourCommitmentTitle
              ourCommitmentTitleMobile
              ourCommitmentButton
              helpMeChooseTitle
              helpMeChooseBody
              helpMeChooseButton
              findYourCar
              heroImageAlt
              bannerTitle
              bannerSubTitle
              articles {
                title
                cta
              }
              reviews {
                title
                cta
              }
            }
            findYourCar {
              allCars
            }
            valuationModule {
              title
              body
              inputLabel
              placeholder
              submitLabel
            }
          }
        }
      }
      prismic {
        allArticles(first: 4, sortBy: meta_lastPublicationDate_DESC) {
          edges {
            node {
              _meta {
                uid
                firstPublicationDate
              }
              lead_paragraph
              title
              main_image
            }
          }
        }
      }
      largeHeroImage: file(relativePath: { eq: "hero-hand.png" }) {
        childImageSharp {
          fluid(maxWidth: 1157, quality: 80) {
            src
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      smallHeroImage: file(relativePath: { eq: "hero-hand.png" }) {
        childImageSharp {
          fluid(maxWidth: 480, quality: 80) {
            src
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  const i18n = data.allTranslations.edges[0].node
  const { edges } = data.prismic.allArticles
  const heroImage = {
    l: {
      webp: data.largeHeroImage.childImageSharp.fluid.srcWebp,
      png: data.largeHeroImage.childImageSharp.fluid.src,
    },
    s: {
      webp: data.smallHeroImage.childImageSharp.fluid.srcWebp,
      png: data.smallHeroImage.childImageSharp.fluid.src,
    },
  }

  const formattedArticles = edges.map(({ node: { _meta: { uid }, lead_paragraph, title, main_image } }: any) => ({
    id: uid,
    featured: false,
    headline: title,
    description: lead_paragraph[0].text,
    image: main_image && main_image.url,
    link: `/post/${uid}`,
  }))

  return (
    <>
      <SEO title={i18n.home.seo.title} desc={i18n.home.seo.description} />
      {hasFeatureFlag(FEATURES.CAMBRIDGE) ? (
        <HomePage i18n={i18n} heroImage={heroImage} articles={formattedArticles} />
      ) : (
        <OxfordHomePage i18n={i18n} heroImage={heroImage} articles={formattedArticles} />
      )}
    </>
  )
}

export default Home
